<template>
  <transition @appear="enter" @enter="enter" @leave="leave" :css="false">
    <div class="PricesHome" v-observe-visibility="onIntersect">
      <p class="PricesHome-span">{{ span }}</p>
      <h1 class="PricesHome-title">{{ title }}</h1>
      <div>
        <p v-html="description" />
        <div
          class="PricesHome-cta"
          @click="explore"
          onclick="window.dataLayer.push({'articleName': 'Premios'})"
        >
          <span>{{ ctaText }}</span>
          <CircleButton />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { TweenMax } from "gsap";
import CircleButton from "@/components/CircleButton";

export default {
  name: "PricesHome",
  props: {
    title: String,
    description: String,
    ctaText: String,
    width: Number,
    height: Number,
    span: String,
  },
  components: {
    CircleButton,
  },
  data: () => ({
    images: {
      logo: require("@/assets/img/logo.svg"),
    },
  }),
  methods: {
    onIntersect(isVisible) {
      if (isVisible) this.$emit("activeChange", 0);
    },
    enter(el, done) {
      el.children.forEach((child, index, arr) => {
        const _done = index === arr.length - 1 ? done : () => {};
        const delay = 0.5 + index * 0.1;

        TweenMax.fromTo(
          child,
          0.5,
          {
            autoAlpha: 0,
            y: 30,
            onComplete: _done,
          },
          {
            autoAlpha: 1,
            y: 0,
            delay: delay,
            ease: "power2.easeInOut",
          },
        );
      });
    },
    leave(el, done) {
      el.children.forEach((child, index, arr) => {
        const _done = index === arr.length - 1 ? done : () => {};

        TweenMax.to(child, 0.2, {
          autoAlpha: 0,
          onComplete: _done,
          ease: "power2.easeInOut",
        });
      });
    },
    explore() {
      const elBounds = this.element.getBoundingClientRect();
      const parent = this.$parent.$el;

      const elems = [...[document.body, document.documentElement], parent];
      if (elBounds) {
        TweenMax.to(elems, 0.5, {
          scrollTop: elBounds.y,
          ease: "power2.easeInOut",
        });
      }
    },
  },
  computed: {
    element() {
      return this.$parent.$refs["section-0"][0].$el;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import './PricesHome.styl';
</style>
